import React from 'react';

export type TextDividerProps = {
  className?: string;
  style?: React.CSSProperties;
  color?: string;
  thickness?: string | number;
};

export const TextDivider: React.FC<
  React.PropsWithChildren<TextDividerProps>
> = ({
  className,
  style,
  children,
  color = 'var(--bs-secondary-color)',
  thickness = '1px',
}) => {
  return (
    <div
      className={
        'd-flex align-items-center justify-content-center w-100 my-3' +
        (className ? ` ${className}` : '')
      }
      style={{ height: thickness, overflow: 'visible', color, ...style }}
    >
      <span
        className="d-flex me-1"
        style={{
          flex: 1,
          height: thickness,
          content: '" "',
          backgroundColor: color,
        }}
      ></span>
      {children}
      <span
        className="d-flex ms-1"
        style={{
          flex: 1,
          height: thickness,
          content: '" "',
          backgroundColor: color,
        }}
      ></span>
    </div>
  );
};
